export default class HereAPI {
  public readonly HERE_API_KEY: string | undefined;
  public readonly PLACE_INDEX: string | undefined;

  constructor() {
    this.HERE_API_KEY = process.env.REACT_APP_HERE_API_KEY;
    this.PLACE_INDEX = process.env.REACT_APP_PLACE_INDEX;
  }
}
